<template>
  <v-main>
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" :loading="loading">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('AUTH.LOGIN_FORM') }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-form v-model="valid" @submit.prevent="login">
                <v-text-field
                  v-model="credentials.login"
                  :label="`${$t('AUTH.USERNAME')} / ${$t('AUTH.EMAIL')} *`"
                  prepend-icon="mdi-mail"
                  type="text"
                  autofocus
                  :rules="rules.login"
                  :error-messages="errorsWithoutForm"
                  @input="clearLoginErrors"
                />

                <v-text-field
                  v-model="credentials.password"
                  :label="`${$t('AUTH.PASSWORD')} *`"
                  prepend-icon="mdi-lock"
                  type="password"
                  :rules="rules.password"
                  :error-messages="errorsWithoutForm"
                  @input="clearLoginErrors"
                />

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    type="submit"
                    color="primary"
                    :loading="loading"
                    :disabled="!valid"
                    >{{ $t('AUTH.LOGIN') }}</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import {
  notEmpty,
  notEmoji,
  maxLength
} from '@/modules/_global/variables/rules';
import errors from '@/modules/_global/mixins/errors';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Login',

  mixins: [errors],

  data: () => ({
    valid: false,
    credentials: {
      login: '',
      password: ''
    },
    rules: {
      login: [notEmpty, notEmoji, maxLength(255)],
      password: [notEmpty]
    }
  }),

  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('auth', ['hasToken']),

    errorsWithoutForm() {
      return ['login', 'email', 'username']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  created() {
    if (this.hasToken) {
      this.redirect();
    }
  },

  methods: {
    ...mapActions('auth', ['retrieveToken', 'retrievePermissions']),

    login() {
      this.retrieveToken(this.credentials)
        .then(({ data: { user } }) => {
          return this.retrievePermissions(user.id).catch(({ response }) => {
            this.handleErrorsByResponse(response);
          });
        })
        .then(() => {
          this.redirect();
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    },

    redirect() {
      this.$router.push({ name: 'home' });
    },

    clearLoginErrors() {
      this.clearErrorByName('login');
      this.clearErrorByName('email');
      this.clearErrorByName('username');
    }
  }
};
</script>
